// extracted by mini-css-extract-plugin
export default {"header":"client_header__FvPx5","header__text":"client_header__text__92HdP","header__addButtonText":"client_header__addButtonText__qO9PP"};